import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToHashOnFirstRender = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      return;
    }

    // setTimeout = push onto callback queue so it runs after the DOM is updated
    setTimeout(() => {
      const selector = location.hash.split("#")?.[1];

      if (!selector) return;

      const element = document.getElementById(selector);

      if (element) {
        const topOffset = element.getBoundingClientRect().top + window.pageYOffset - 25;
        window.scrollTo({ top: topOffset, behavior: "smooth" });
      }
    }, 500);

    // no deps = only run once on first render
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
